import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Display,
  Heading2,
  Heading3,
  Icon,
  IconVariant,
  JustifyContent,
  Space,
} from '@gousto-internal/citrus-react'

import { LandingPageButton, TwoColumnLayout } from '../../../../components'
import type { HowGoustoFoodBoxesWorkTypes } from '../../../../types/'
import { FoodBoxPageSections, TargetUri, TrackingActions } from '../../../../types/tracking'
import familykitchen from '../../../../sections/assets/familykitchen.webp'
import { GIVE_GOUSTO_A_GO } from './config'

export function GiveGoustoAGoSection({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <TwoColumnLayout image={{ src: familykitchen, alt: GIVE_GOUSTO_A_GO.altText }}>
      <Box width="100%">
        <Heading2>{GIVE_GOUSTO_A_GO.heading}</Heading2>
        <Space size={3} />
        <Body2 size={4}>{GIVE_GOUSTO_A_GO.body1}</Body2>
        <Space size={4} />
        <Body2 size={4}>{GIVE_GOUSTO_A_GO.body2}</Body2>
        <Space size={6} />
        <Heading3>{GIVE_GOUSTO_A_GO.subheadingBold}</Heading3>
        <Body2 size={4}>{GIVE_GOUSTO_A_GO.subheading}</Body2>
        <Space size={3} />

        <Box display={Display.Flex} alignItems={AlignItems.Center} paddingBottom={2}>
          <Icon name="tick" variant={IconVariant.Confirmation} data-testid="tick" />
          <Box paddingH={2}>
            <Body2 size={4}>
              <strong>50% OFF</strong> your first box
            </Body2>
          </Box>
        </Box>

        <Box display={Display.Flex} alignItems={AlignItems.Center} paddingBottom={2}>
          <Icon name="tick" variant={IconVariant.Confirmation} data-testid="tick" />
          <Box paddingH={2}>
            <Body2 size={4}>
              <strong>40% OFF</strong> your second
            </Body2>
          </Box>
        </Box>

        <Box display={Display.Flex} alignItems={AlignItems.Center}>
          <Icon name="tick" variant={IconVariant.Confirmation} data-testid="tick" />
          <Box paddingH={2}>
            <Body2 size={4}>
              <strong>20% OFF</strong> all other boxes for two whole months
            </Body2>
          </Box>
        </Box>

        <Space size={4} />
        <Body2 size={4}>{GIVE_GOUSTO_A_GO.body3}</Body2>
        <Space size={6} />
        <Box
          display={Display.Flex}
          justifyContent={[JustifyContent.Center, JustifyContent.FlexStart]}
        >
          <LandingPageButton
            startOnboarding={startOnboarding}
            sectionName={FoodBoxPageSections.GIVE_GOUSTO_A_GO_SECTION}
            target={TargetUri.SIGNUP}
            action={TrackingActions.CLICK_GET_STARTED}
          >
            {GIVE_GOUSTO_A_GO.ctaText}
          </LandingPageButton>
        </Box>
      </Box>
    </TwoColumnLayout>
  )
}
